// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__15bPj","errorLogs":"styles_errorLogs__14GDj"};